import { useOutletContext } from "react-router-dom";

import HomeNarratorView from "../views/HomeNarratorView";

export default function HomeNarrator() {
	const { organization } = useOutletContext();

	return <HomeNarratorView organization={organization} />;
}
